import React, { useState, useEffect } from "react";
import { environment } from "../../../environment";
import axios from "axios";
import { Form, Button, Dropdown } from "react-bootstrap";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import { LinkContainer } from "react-router-bootstrap";
import NavbarNew from "../../Components/NavbarNew";
const { SearchBar } = Search;

const MySwal = withReactContent(Swal);

const LeadUserFeedback = ({ history }) => {
  const [customers, setCustomers] = useState([]);
  const [email, setEmail] = useState("");
  const [customerCount, setCustomerCount] = useState("");
  const [totalWeightage, setTotalWeightage] = useState([{}]);
  const [updatedDate, setUpdatedDate] = useState([]);
  let totalResponseWaitageArray = [{}];
  let ResponseWaitageArray = [];
  let customersArray = [];
  let master_dropdown = [];
  master_dropdown = [
    {
      questionMasterName: "Customer Feedback",
      questionMasterId: 1,
    },
    {
      questionMasterName: "Voluntary Feedback(Before using purifier)",
      questionMasterId: 2,
    },
    {
      questionMasterName: "Voluntary Feedback(After using purifier)",
      questionMasterId: 3,
    },
  ];

  useEffect(() => {
    axios
      .post(environment.dap_url + "getAllResponsesById")
      .then((res) => {
        console.log(res.data);

        const userData = JSON.parse(localStorage.getItem("user"));
        const customerWiseData = res.data.filter(
          (item) => item.createdBy == userData._id
        );
        setCustomers(customerWiseData);
        customersArray.push(customerWiseData);
        console.log(customerWiseData.length);
        setCustomerCount(customerWiseData.length);
        console.log(customerWiseData);
        //getTotalWeighatge(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const columns = [
    {
      dataField: "sl.no",
      text: "Sl no.",
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1;
      },
      sort: true,
    },
    {
      dataField: "_id",
      text: "Date",
      sort: true,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        const urLength = row.questionData.length;
        const urData = row.questionData[urLength - 1];
        console.log(urData);
        if (urData !== undefined) {
          const date = new Date(urData.updatedAt);
          const isValidDate = !isNaN(date.getTime());
          const formattedDate = isValidDate
            ? `${date.getDate().toString().padStart(2, "0")}-${(
                date.getMonth() + 1
              )
                .toString()
                .padStart(2, "0")}-${date.getFullYear().toString()}`
            : "";
          console.log(formattedDate);
          return formattedDate;
        }
      },
    },
    {
      dataField: "organization",
      text: "Organisation",
      sort: true,
    },
    {
      dataField: "fullName",
      text: "Name",
      sort: true,
      formatter: (cell, row) => `${row.userFirstName} ${row.userLastName}`,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
    },
    {
      dataField: "address",
      text: "Address",
      sort: true,
    },
    {
      dataField: "_id",
      text: "Customer Feedback",
      sort: false,
      formatter: (dataField) => {
        return (
          <div>
            <LinkContainer
              to={`/viewResponse/${dataField}/1`}
              style={{
                float: "center",
              }}
            >
              <Button variant="light" className="btn-sm ">
                View
                <i className="fa fa-eye"></i>
              </Button>
            </LinkContainer>
          </div>
        );
      },
    },
  ];

  const defaultSorted = [
    {
      dataField: "questionResponses[0].createdAt",
      order: "desc",
    },
  ];

  return (
    <>
      <div class="container-fluid">
        <NavbarNew />
        <div className="row">
          <div className="col-12">
            <div className="card-body">
              <h4 className="card-title">CUSTOMERS</h4>
              <div className="row">
                <div className="col-12">
                  <ToolkitProvider
                    keyField="id"
                    bootstrap4
                    data={customers}
                    columns={columns}
                    search
                  >
                    {(props) => (
                      <div>
                        <div className="d-flex align-items-center">
                          <p className="mb-2 mr-2">Search in table:</p>
                          <SearchBar {...props.searchProps} />
                        </div>
                        <BootstrapTable
                          defaultSorted={defaultSorted}
                          pagination={paginationFactory()}
                          {...props.baseProps}
                          wrapperClasses="table-responsive"
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <h5 style={{ marginLeft: "5%" }}>
        Total number of Customers: {customerCount}
      </h5> */}
    </>
  );
};

export default LeadUserFeedback;
